export default __webpack_public_path__ + "static/media/ProductSans-Light.9495ac60.svg";